import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutFooter from "../components/footer";
import axios from "../../axios";
import usePageTitle from "../pageTitle";
import {
  // Container,
  Box,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  Typography,
  Paper,
  Button,
  TextField,
} from "@mui/material";

function SmmCampaignReviewPage() {
  usePageTitle("Content Upload");
  const { ref } = useParams();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [showLoading, setShowLoading] = useState(false);
  const [ad, setAd] = useState(null);
  const [reason, setReason] = useState(null);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    setShowLoading(true);
    const fetchData = async () => {
      await axios
        .get(`smm/ad/${ref}/reviewInit.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setAd(result.data.data.ad);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function submit(status = false) {
    if (!status) {
      if (reason === null) {
        setSeverity("error");
        setErrMsg("Rejection reason required.");
        setOpen(true);
        return;
      }
    }

    setShowLoading(true);
    const json = {
      reference: ref,
      approved: status,
      reason: `${reason}`,
    };

    await axios
      .post("smm/ad/review.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
        } else {
          setSeverity("error");
        }
        setErrMsg(result.data.data.message);
        setOpen(true);
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  return (
    <>
      <Box mb={5}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
      </Box>
      {ad && (
        <Box sx={{ width: "100%", maxWidth: "600px", margin: "65px auto" }}>
          <Box p={3}>
            <Paper elevation={3}>
              <Box p={2}>
                <Box>
                  <Typography variant="h6">Ad</Typography>
                  <Typography variant="h6" fontWeight="light" fontSize={14}>
                    {ad.title}
                  </Typography>
                </Box>
                <Box mt={3}>
                  <Typography variant="h6">Caption</Typography>
                  <Typography variant="h6" fontWeight="light" fontSize={14}>
                    {ad.caption}
                  </Typography>
                </Box>
                <Box mt={3}>
                  <Typography variant="h6">Media</Typography>
                  {ad.media.map((item) => (
                    <Typography
                      variant="h6"
                      fontSize={14}
                      fontWeight="light"
                      my={1}
                    >
                      <a href={item} target="_blank" rel="noreferrer">
                        {item}
                      </a>
                    </Typography>
                  ))}
                </Box>
                <Box mt={5}>
                  <Box>
                    <TextField
                      fullWidth
                      multiline
                      label="Rejection Reason"
                      minRows={3}
                      onChange={(e) => setReason(e.target.value)}
                    />
                  </Box>
                  <Box mt={3}>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => submit(true)}
                    >
                      Approve
                    </Button>
                    &nbsp;
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => submit(false)}
                    >
                      Reject
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Box>
        </Box>
      )}
      <CheckoutFooter />
    </>
  );
}

export default SmmCampaignReviewPage;
